<template>
  <div class="panel-wraper">
    <p class="panel-text">您尚未开通销售线索的权限</p>
    <div class="panel-icon">
      <img :src="url"
           alt="图像加载失败">
    </div>
    <p class="panel-content">{{content}}</p>
    <p class="panel-text">联系商务，我们告诉您</p>
  </div>
</template>

<script>
// 公用实现面板
export default {
  props: {
    content: String,
    url: String,
  },
}
</script>

<style lang="scss" scoped>
$color: #999999;
$line_height: 30px;
.panel-wraper {
  text-align: center;
  padding: 10px 0;
  .panel-text {
    font-size: 12px;
    margin-bottom: 10px;
    color: $color;
    line-height: $line_height;
  }
  .panel-content {
    font-size: 16px;
    color: $color;
    line-height: $line_height;
  }
}
</style>